import { createContext, ReactNode } from 'react';

export interface HeaderContextType {
  headerContent: ReactNode;
  setHeaderContent: (content: ReactNode) => void;
  headerRightContent: ReactNode;
  setHeaderRightContent: (content: ReactNode) => void;
  isLoading: boolean;
  setLoading: (loading: boolean) => void;
}

export const HeaderContext = createContext<HeaderContextType>({
  headerContent: null,
  setHeaderContent: () => {},
  headerRightContent: null,
  setHeaderRightContent: () => {},
  isLoading: false,
  setLoading: () => {},
});
